import { LearnerListing, AddLearner, MemberpriceApplied, AddWaitingList, WaitingListListing } from './modal.js';
import CartService from '../service/CartService.js';

export default class Learner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.data.id,
      name: this.props.title,
      type: this.props.data.type,
      key: this.props.data.type + '_' + this.props.data.id,
      learnerlisting: false,
      waitinglistlisting: false,
      showmodal: false,
      showWaitingListModal: false,
      addlearner: false,
      addWaitingList: false,
      isedit: false,
      memberMsg: '',
      memberStatus: false,
      item: CartService.getCartItem(
        this.props.data.type + '_' + this.props.data.id
      ),
      learners: [],
      itemPrice: [],
      waitingList: [],
      applied_coupon_detail: _couponApplied.data
    };
  }

  componentDidMount() {
    this.state.learners = CartService.getLearner(this.state.key);
    this.state.waitingList = CartService.getWaitingList(this.state.key);
    this.state.itemPrice = CartService.getitemprice(this.state.key);
  }

  refresh = () => {
    this.props.refresh();
  };

  dissmissmodal = () => {
    this.setState({
      showmodal: false,
      learnerlisting: false,
      addlearner: false,
    });
  };
  dissmissmodal_addlearner = () => {
    this.setState({
      addlearner: false,
    });
  };

  dissmisswaitmodal = () => {
    this.setState({
      showWaitingListModal: false,
      waitinglistlisting: false,
      addWaitingList: false,
      addlearner: false 
    });
  };
  dissmisswaitmodal_addwaitinglist = () => {
    this.setState({
      addWaitingList: false,
      addlearner: false 
    });
  };

  dissmissmodal_membermsg = () => {
    this.setState({
      memberStatus: false,
      memberMsg: '',
    });
    // check for coupon first

    if (this.state.applied_coupon_detail && Number(this.state.applied_coupon_detail.pc_subscriber_coupons_limit) > 0)
    {
      var check_limit = this.state.applied_coupon_detail.pc_subscriber_coupons_remaining ? this.state.applied_coupon_detail.pc_subscriber_coupons_remaining : 0;
      var prevLimit   = localStorage.getItem('coupon_limit_usage');
      var masterLimit = localStorage.getItem('main_coupon_limit');

      if (masterLimit > prevLimit)
      {
        localStorage.setItem('coupon_limit_usage', check_limit);
      }
    }

    this.props.refresh();
  };

  show_membermsg = (msgStatus) => {
    this.setState({
      memberStatus: true,
      memberMsg: msgStatus,
    });
  };

  learnerlisting = () => {
    this.setState({
      learnerlisting: true,
    });
  };
  waitinglistlisting = () => {
    this.setState({
      waitinglistlisting: true,
    });
  };
  addlearner = () => {
    if (
      this.state.item.others.remining_seats != -1 &&
      this.state.item.others.remining_seats -
        Object.keys(this.state.learners).length <=
        0
    ) {
      if (
        this.state.type == 'booking_event' &&
        this.state.item.others.haswaitinglist == '1'
      ) {
        this.setState({
          addWaitingList: true,
          setdata: null,
          waitinglistindex: null,
        });
      } else {
        return false;
      }
    }
    this.setState({
      addlearner: true,
      setdata: null,
      learnerindex: null,
    });
  };
  removelearner = (param) => {
    CartService.removeLearner(this.state.key, param);
    this.refresh();
  };
  removeWaitingList = (param) => {
    CartService.removeWaitingList(this.state.key, param);
    this.refresh();
  };
  editlearner = (param, index, key = null) => {
    this.setState({
      setdata: param,
      isedit: true,
      learnerindex: index,
      key: key ? key : this.state.key,
      frompopup: key ? 1 : 0,
      addlearner: true,
    });
  };

  editWaitingList = (param, index, key = null) => {
    this.setState({
      setdata: param,
      isedit: true,
      learnerindex: index,
      key: key ? key : this.state.key,
      frompopup: key ? 1 : 0,
      addWaitingList: true,
    });
  };

  render() {
    var { id, type, item } = this.state;
    var learners_count = Object.keys(this.state.learners)
      ? Object.keys(this.state.learners).length
      : 0;
    var learners = Object.keys(this.state.learners)
      .reverse()
      .reduce((obj, key) => {
        obj[key] = this.state.learners[key];
        return obj;
      }, {});
    var new_discount_price = 0;
    if (item.others.discount_type && item.others.discount_type == '1' && Number(item.others.discount_percent) > 0) {
      this.state.itemPrice.discount_price = Number(item.others.price) - (Number(item.others.discount_price))
    }

      // waiting list 
      var waitinglist_count = Object.keys(this.state.waitingList)
      ? Object.keys(this.state.waitingList).length
      : 0;
      var waitingList = Object.keys(this.state.waitingList)
      .reverse()
      .reduce((obj, key) => {
        obj[key] = this.state.waitingList[key];
        return obj;
      }, {});
    var new_discount_price = 0;
    if (item.others.discount_type && item.others.discount_type == '1' && Number(item.others.discount_percent) > 0) {
      this.state.itemPrice.discount_price = Number(item.others.price) - (Number(item.others.discount_price))
    }

    const key = this.state.key;
    const cart = JSON.parse(localStorage.getItem('mycart'));
    // IF LIMIT SUBSCRIBER ENABLE
    if (this.state.applied_coupon_detail && Number(this.state.applied_coupon_detail.pc_subscriber_coupons_limit) > 0)
    {
      
      var coupon_limit_usage_found  = 1;
      var coupon_limit_usage_count = this.state.applied_coupon_detail.pc_subscriber_coupons_remaining;
      var coupon_limit_localstorage = localStorage.getItem('coupon_limit_usage');
      var count_limit               = 0;
      if (!coupon_limit_localstorage)
      {
        localStorage.setItem('coupon_limit_usage', coupon_limit_usage_count);
        localStorage.setItem('main_coupon_limit',  coupon_limit_usage_count);
        coupon_limit_localstorage = localStorage.getItem('coupon_limit_usage');
      }
    }

    if (coupon_limit_localstorage != 0)
    {
      var modifiedLearners = Object.keys(learners).length != 0 &&
                              Object.keys(learners).reverse()
                                .map((index, int_index) => {
                                  if (this.state.applied_coupon_detail && this.state.applied_coupon_detail.pc_coupon_type !== '')
                                  {
                                    // LIMIT SUBSCRIBER ENABLE
                                    if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                    {
                                      if(this.state.applied_coupon_detail.pc_customized_data) {
                                        var item_name;
                                        var found = 0;
                                        var booking_id = 0;
                                        if(!Array.isArray(JSON.parse(this.state.applied_coupon_detail.pc_customized_data).course_bundle)) {
                                          if (this.state.type == 'course' && found == 0)
                                          {
                                            item_name = 'course_' + this.state.item.id;
                                          } else if (this.state.type == 'bundle') {
                                            item_name = 'bundle_' + this.state.item.id;
                                          }
                                          if (item_name in JSON.parse(this.state.applied_coupon_detail.pc_customized_data).course_bundle) {
                                            var customized_coupon = JSON.parse(this.state.applied_coupon_detail.pc_customized_data).course_bundle;
                                            found = 1;
                                          }
                                        }
                                        if(!Array.isArray(JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_course)) {

                                          if (this.state.type == 'booking_event' && found == 0)
                                          {
                                            item_name = 'training_course_' + this.state.item.course_id;
                                          }
                                          if (item_name in JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_course) {
                                            var customized_coupon = JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_course;
                                            found = 1;
                                            booking_id = this.state.item.course_id;
                                          }
                                        }
                                        if(!Array.isArray(JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_events)) {
                                          if (this.state.type == 'booking_event' && found == 0)
                                          {
                                            item_name = 'training_event_' + this.state.item.id;
                                          }
                                          if (item_name in JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_events) {
                                            var customized_coupon = JSON.parse(this.state.applied_coupon_detail.pc_customized_data).training_events;
                                            found = 1;
                                            booking_id = this.state.item.id;
                                          }
                                        }
                                        var state_id = this.state.item.type == "booking_event" ? booking_id : this.state.item.id;
                                      }
                                    }

                                    if (coupon_limit_usage_found && coupon_limit_usage_found == 1)
                                    {
                                      // FOR BOTH MEMBER AND NON MEMBER
                                      if(this.state.applied_coupon_detail.pc_coupon_option == 2) 
                                      {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                                            learners[index].is_bulk_learner_discount = 1;
                                            
                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                  if (state_id === customized_coupon[item_name].id) {
                                                    // DISCOUNT TYPE
                                                    if (_couponApplied.data.pc_discount_type == 1)
                                                    {
                                                      if (_couponApplied.data.pc_is_bulk_learner_price && _couponApplied.data.pc_is_bulk_learner_price == 1)
                                                      {
                                                        learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.member_price;
                                                          learners[index].total_after_discount = 0;
                                                        }
                                                      }
                                                    } 
                                                    else if (_couponApplied.data.pc_discount_type == 0)
                                                    {
                                                      if (_couponApplied.data.pc_is_bulk_learner_percent && _couponApplied.data.pc_is_bulk_learner_percent == 1)
                                                      {
                                                        if (_couponApplied.data.pc_maximum_discount)
                                                        {
                                                          learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                          if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                          }
                                                          learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                        }
                                                        else
                                                        {
                                                          learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                          learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                        }
                                                      }
                                                    }

                                                    if (coupon_limit_localstorage > 0)
                                                    {
                                                      --coupon_limit_localstorage;
                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                  }
                                              }
                                            } else {
                                              if (_couponApplied.data.pc_discount_type == 1)
                                              {
                                                if (_couponApplied.data.pc_is_bulk_learner_price && _couponApplied.data.pc_is_bulk_learner_price == 1)
                                                {
                                                  learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.member_price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                              } 
                                              else if (_couponApplied.data.pc_discount_type == 0)
                                              {
                                                if (_couponApplied.data.pc_is_bulk_learner_percent && _couponApplied.data.pc_is_bulk_learner_percent == 1)
                                                {
                                                  if (_couponApplied.data.pc_maximum_discount)
                                                  {
                                                    learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                    if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                    }

                                                    learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                  }
                                                  else
                                                  {
                                                    learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                    learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                  }
                                                }
                                              }
                                              if (coupon_limit_localstorage > 0)
                                              {
                                                --coupon_limit_localstorage;
                                              } else {
                                                learners[index].is_bulk_learner_discount = 0;
                                                learners[index].discount_price = 0;
                                                learners[index].total_after_discount = 0;
                                              }
                                            }
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        } else { 
                                          //For Non-Membership
                                          if(this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1 || this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1) 
                                          {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                  if (state_id === customized_coupon[item_name].id) {
                                                    // DISCOUNT TYPE 
                                                    if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                                    {
                                                      if (this.state.applied_coupon_detail.pc_is_bulk_learner_price && this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1)
                                                      {
                                                        learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                          learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                          if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                          {
                                                            learners[index].discount_price = this.state.itemPrice.discount_price;
                                                            learners[index].total_after_discount = 0;
                                                            }
                                                        } else {
                                                          learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                          if (learners[index].discount_price > this.state.itemPrice.price)
                                                          {
                                                            learners[index].discount_price = this.state.itemPrice.price;
                                                            learners[index].total_after_discount = 0;
                                                          }
                                                        }
                                                      }
                                                    } 
                                                    else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                                    {
                                                      if (this.state.applied_coupon_detail.pc_is_bulk_learner_percent && this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1)
                                                      {
                                                        if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                        {
                                                          if (this.state.itemPrice.discount_price > 0)
                                                          {
                                                            if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                            {
                                                              learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                            } else {
                                                              learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                            }
                                                            learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;
    
                                                          } else {
                                                            if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                            {
                                                              learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                            } else {
                                                              learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                            }
                                                            learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                          }
                                                        }
                                                        else
                                                        {
                                                          if (this.state.itemPrice.discount_price > 0)
                                                          {
                                                              learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                              learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                          } else {
                                                              learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                              learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                          }
                                                        }
                                                      }
                                                    }

                                                    if (coupon_limit_localstorage > 0)
                                                    {
                                                      --coupon_limit_localstorage;
                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                    
                                                  }

                                              }
                                            } else {
                                              // DISCOUNT TYPE 
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {
                                                if (this.state.applied_coupon_detail.pc_is_bulk_learner_price && 
                                                    this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1)
                                                {
                                                  learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  { 
                                                    learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                    if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                    {
                                                      learners[index].discount_price = this.state.itemPrice.discount_price;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                  } else {
                                                    learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                    if (learners[index].discount_price > this.state.itemPrice.price)
                                                    {
                                                      learners[index].discount_price = this.state.itemPrice.price;
                                                      learners[index].total_after_discount = 0;

                                                    }
                                                  }
                                                }
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                if (this.state.applied_coupon_detail.pc_is_bulk_learner_percent && 
                                                  this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1)
                                                {
                                                  if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                  {
                                                    if (this.state.itemPrice.discount_price > 0)
                                                    {
                                                      if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                      {
                                                        learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                      } else {
                                                        learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                      }
                                                      learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                    } else {
                                                      if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                      {
                                                        learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                      } else {
                                                        learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                      }
                                                      learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                    }
                                                  }
                                                  else
                                                  {
                                                    if (this.state.itemPrice.discount_price > 0)
                                                    {
                                                        learners[index].discount_price       = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                        learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;
                                                    } else {
                                                        learners[index].discount_price       = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                        learners[index].total_after_discount = Number(this.state.itemPrice.price) - learners[index].discount_price;
                                                    }
                                                  }
                                                }
                                              }
                                              if (coupon_limit_localstorage > 0)
                                              {
                                                --coupon_limit_localstorage;
                                              } else {
                                                learners[index].is_bulk_learner_discount = 0;
                                                learners[index].discount_price = 0;
                                                learners[index].total_after_discount = 0;
                                              }
                                            }
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        }
                                        
                                      } else if (this.state.applied_coupon_detail.pc_coupon_option == 1) {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                if (state_id === customized_coupon[item_name].id) {
                                                  // DISCOUNT TYPE
                                                  if (_couponApplied.data.pc_discount_type == 1)
                                                  {
                                                    if (this.state.applied_coupon_detail.pc_is_bulk_learner_price && 
                                                        this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1)
                                                    {
                                                      learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                      learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                      {
                                                        learners[index].discount_price = this.state.itemPrice.member_price;
                                                        learners[index].total_after_discount = 0;
                                                      }
                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                      
          
                                                  } 
                                                  else if (_couponApplied.data.pc_discount_type == 0)
                                                  {
                                                    if (_couponApplied.data.pc_maximum_discount)
                                                    {
                                                      learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                      if (learners[index].discount_price  > Number(_couponApplied.data.pc_maximum_discount))
                                                      {
                                                        learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                      }
                                                      learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                    }
                                                    else
                                                    {
                                                      learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                      learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                    }
                                                  }
                                                  if (coupon_limit_localstorage > 0)
                                                  {
                                                    --coupon_limit_localstorage;
                                                  } else {
                                                    learners[index].is_bulk_learner_discount = 0;
                                                    learners[index].discount_price = 0;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                              }

                                            } else {
                                              if (_couponApplied.data.pc_discount_type == 1)
                                              {
                                                learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                {
                                                  learners[index].discount_price = this.state.itemPrice.member_price;
                                                  learners[index].total_after_discount = 0;
                                                }
                                              } 
                                              else if (_couponApplied.data.pc_discount_type == 0)
                                              {
                                                if (_couponApplied.data.pc_maximum_discount)
                                                {
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  if (learners[index].discount_price  > Number(_couponApplied.data.pc_maximum_discount))
                                                  {
                                                    learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                  }
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                                else
                                                {
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                              }
                                              if (coupon_limit_localstorage > 0)
                                              {
                                                --coupon_limit_localstorage;
                                              } else {
                                                learners[index].is_bulk_learner_discount = 0;
                                                learners[index].discount_price = 0;
                                                learners[index].total_after_discount = 0;
                                              }
                                            }
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        } else {  
                                          //For Non-Membership
                                          learners[index].is_bulk_learner_discount = 0;
                                          learners[index].discount_price = 0;
                                          learners[index].total_after_discount = 0;
                                        }
                                      } else if(this.state.applied_coupon_detail.pc_coupon_option == 0) {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          learners[index].is_bulk_learner_discount = 0;
                                          learners[index].discount_price = 0;
                                          learners[index].total_after_discount = 0;
                                          
                                        } else { 
                                          //For Non-Membership
                                          if(this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1 || this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1) 
                                          {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              // DISCOUNT TYPE 
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {

                                                if (typeof customized_coupon !== 'undefined')
                                                {
                                                    if (state_id === customized_coupon[item_name].id) {
                                                      
                                                      learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                      
                                                      if (this.state.itemPrice.discount_price > 0)
                                                      {
                                                        learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                          if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                          {
                                                            learners[index].discount_price = this.state.itemPrice.discount_price;
                                                            learners[index].total_after_discount = 0;
                                                          }
                                                      } else {
                                                        learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.price;
                                                          learners[index].total_after_discount = 0;

                                                        }
                                                      }

                                                      if (coupon_limit_localstorage > 0)
                                                      {
                                                        --coupon_limit_localstorage;
                                                      } else {
                                                        learners[index].is_bulk_learner_discount = 0;
                                                        learners[index].discount_price = 0;
                                                        learners[index].total_after_discount = 0;
                                                      }

                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                }
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                if (typeof customized_coupon !== 'undefined')
                                                {
                                                  if (state_id === customized_coupon[item_name].id) {
                                                      
                                                      if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                          if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                        } else {
                                                          if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }
                                                      else
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                            learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                        } else {
                                                            learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }
                                                      if (coupon_limit_localstorage > 0)
                                                      {
                                                        --coupon_limit_localstorage;
                                                      } else {
                                                        learners[index].is_bulk_learner_discount = 0;
                                                        learners[index].discount_price = 0;
                                                        learners[index].total_after_discount = 0;
                                                      }

                                                  } else {
                                                    learners[index].is_bulk_learner_discount = 0;
                                                    learners[index].discount_price = 0;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                              }
                                            } else if (this.state.applied_coupon_detail.pc_coupon_type == 0) { 
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {
                                                learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                
                                                if (this.state.itemPrice.discount_price > 0)
                                                {
                                                  learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.discount_price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                } else {
                                                  learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                                if (coupon_limit_localstorage > 0)
                                                {
                                                  --coupon_limit_localstorage;
                                                } else {
                                                  learners[index].is_bulk_learner_discount = 0;
                                                  learners[index].discount_price = 0;
                                                  learners[index].total_after_discount = 0;
                                                }
                                                
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                
                                                if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                    if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                  } else {
                                                    if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  }
                                                }
                                                else
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                      learners[index].discount_price       = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                      learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;
                                                  } else {
                                                      learners[index].discount_price       = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                      learners[index].total_after_discount = Number(this.state.itemPrice.price) - learners[index].discount_price;
                                                  }
                                                }
                                                if (coupon_limit_localstorage > 0)
                                                {
                                                  --coupon_limit_localstorage;
                                                } else {
                                                  learners[index].is_bulk_learner_discount = 0;
                                                  learners[index].discount_price = 0;
                                                  learners[index].total_after_discount = 0;
                                                }
                                              }
                                            }
                                            
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        }
                                      }

                                      localStorage.setItem('coupon_limit_usage', coupon_limit_localstorage);
                                      
                                    } else {

                                      // FOR BOTH MEMBER AND NON MEMBER
                                      if(this.state.applied_coupon_detail.pc_coupon_option == 2) 
                                      {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                                            learners[index].is_bulk_learner_discount = 1;
                                            
                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                  if (state_id === customized_coupon[item_name].id) {
                                                    // DISCOUNT TYPE
                                                    if (_couponApplied.data.pc_discount_type == 1)
                                                    {
                                                      learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                      learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                      {
                                                        learners[index].discount_price = this.state.itemPrice.member_price;
                                                        learners[index].total_after_discount = 0;
                                                      }
                                                    } 
                                                    else if (_couponApplied.data.pc_discount_type == 0)
                                                    {
                                                      if (_couponApplied.data.pc_maximum_discount)
                                                      {
                                                        learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                        if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount))
                                                        {
                                                          learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                        }
                                                        
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      }
                                                      else
                                                      {
                                                        learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      }
                                                    }
                                                  }
                                              }

                                            } else {
                                              if (_couponApplied.data.pc_discount_type == 1)
                                              {
                                                learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                {
                                                  learners[index].discount_price = this.state.itemPrice.member_price;
                                                  learners[index].total_after_discount = 0;
                                                }
                                              } 
                                              else if (_couponApplied.data.pc_discount_type == 0)
                                              {
                                                if (_couponApplied.data.pc_maximum_discount)
                                                {
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount))
                                                  {
                                                    learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                  }
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                                else
                                                {
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                              }
                                            }
    
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        } else { 
                                          //For Non-Membership
                                          if(this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1 || this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1) 
                                          {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                  if (state_id === customized_coupon[item_name].id) {

                                                    // DISCOUNT TYPE 
                                                    if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                                    {
                                                      learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                      if (this.state.itemPrice.discount_price > 0)
                                                      {
                                                        learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.discount_price;
                                                          learners[index].total_after_discount = 0;
                                                        }
                                                      } else {
                                                        learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.price;
                                                          learners[index].total_after_discount = 0;
                                                        }
                                                      }
                                                    } 
                                                    else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                                    {
                                                      if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                          if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                        } else {
                                                          if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }
                                                      else
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                            learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                        } else {
                                                            learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }
                                                    }
                                                    
                                                  }
                                              }
                                              
                                            } else {
                                              // DISCOUNT TYPE 
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {
                                                learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                if (this.state.itemPrice.discount_price > 0)
                                                {   
                                                  learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.discount_price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                } else {
                                                  learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                    if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                  } else {
                                                    if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  }
                                                }
                                                else
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                      learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                      learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                  } else {
                                                      learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                      learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        }
                                      } else if (this.state.applied_coupon_detail.pc_coupon_option == 1) {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          if(_couponApplied.data.pc_is_bulk_learner_price == 1 || _couponApplied.data.pc_is_bulk_learner_percent == 1) {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              if (typeof customized_coupon !== 'undefined')
                                              {
                                                  if (state_id === customized_coupon[item_name].id) {
                                                    // DISCOUNT TYPE
                                                    if (_couponApplied.data.pc_discount_type == 1)
                                                    {
                                                      learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                      learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                      {
                                                        learners[index].discount_price = this.state.itemPrice.member_price;
                                                        learners[index].total_after_discount = 0;
                                                      }
                                                    } 
                                                    else if (_couponApplied.data.pc_discount_type == 0)
                                                    {
                                                      if (_couponApplied.data.pc_maximum_discount)
                                                      {
                                                        learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                        if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount)) 
                                                        {
                                                          learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                        }
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      }
                                                      else
                                                      {
                                                        learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                      }
                                                    }

                                                  }
                                              }

                                            } else {
                                              if (_couponApplied.data.pc_discount_type == 1)
                                              {
                                                if (this.state.applied_coupon_detail.pc_customized_data)
                                                {
                                                  if (typeof customized_coupon !== 'undefined')
                                                  {
                                                      if (state_id === customized_coupon[item_name].id) {
                                                        
                                                        learners[index].discount_price       = Number(_couponApplied.data.pc_discount_rate);
                                                        learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.member_price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.member_price
                                                          learners[index].total_after_discount = 0;
                                                        }

                                                      }
                                                  }
                                                }
                                              } 
                                              else if (_couponApplied.data.pc_discount_type == 0)
                                              {
                                                if (_couponApplied.data.pc_maximum_discount)
                                                { 
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  if (learners[index].discount_price > Number(_couponApplied.data.pc_maximum_discount)) 
                                                  {
                                                    learners[index].discount_price       = Number(_couponApplied.data.pc_maximum_discount);
                                                  }
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                                else
                                                {
                                                  learners[index].discount_price       = this.state.itemPrice.member_price * (_couponApplied.data.pc_discount_rate / 100);
                                                  learners[index].total_after_discount = this.state.itemPrice.member_price - learners[index].discount_price;
                                                }
                                              }
                                            }
    
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        } else {  
                                          //For Non-Membership
                                          learners[index].is_bulk_learner_discount = 0;
                                          learners[index].discount_price = 0;
                                          learners[index].total_after_discount = 0;
                                        }
                                      } else if(this.state.applied_coupon_detail.pc_coupon_option == 0) {
                                        //For Membership
                                        if (_showMember == '1' && learners[index].is_member == '1') {
                                          //For Non-Membership
                                          learners[index].is_bulk_learner_discount = 0;
                                          learners[index].discount_price = 0;
                                          learners[index].total_after_discount = 0;
                                          
                                        } else { 
                                          //For Non-Membership
                                          if(this.state.applied_coupon_detail.pc_is_bulk_learner_price == 1 || this.state.applied_coupon_detail.pc_is_bulk_learner_percent == 1) 
                                          {
                                            learners[index].is_bulk_learner_discount = 1;

                                            if (this.state.applied_coupon_detail.pc_coupon_type == 1 && this.state.applied_coupon_detail.pc_customized_data)
                                            {
                                              // DISCOUNT TYPE 
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {
                                                if (typeof customized_coupon !== 'undefined')
                                                {
                                                    if (state_id === customized_coupon[item_name].id) {
                                                      
                                                      learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                      
                                                      if (this.state.itemPrice.discount_price > 0)
                                                      { 
                                                        learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.discount_price;
                                                          learners[index].total_after_discount = 0;
                                                        }
                                                      } else {
                                                        learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        if (learners[index].discount_price > this.state.itemPrice.price)
                                                        {
                                                          learners[index].discount_price = this.state.itemPrice.price;
                                                          learners[index].total_after_discount = 0;
                                                        }
                                                      }
                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                }
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                if (typeof customized_coupon !== 'undefined')
                                                {
                                                    if (state_id === customized_coupon[item_name].id) {
                                                      
                                                      if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                          if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                        } else {
                                                          if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                          {
                                                            learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                          } else {
                                                            learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                          }
                                                          learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }
                                                      else
                                                      {
                                                        if (this.state.itemPrice.discount_price > 0)
                                                        {
                                                            learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                        } else {
                                                            learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                            learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                        }
                                                      }

                                                    } else {
                                                      learners[index].is_bulk_learner_discount = 0;
                                                      learners[index].discount_price = 0;
                                                      learners[index].total_after_discount = 0;
                                                    }
                                                }
                                              }
                                            } else if (this.state.applied_coupon_detail.pc_coupon_type == 0) {
                                              if (this.state.applied_coupon_detail.pc_discount_type == 1)
                                              {
                                                learners[index].discount_price       = Number(this.state.applied_coupon_detail.pc_discount_rate);
                                                
                                                if (this.state.itemPrice.discount_price > 0)
                                                { 
                                                  learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.discount_price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.discount_price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                } else {
                                                  learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  if (learners[index].discount_price > this.state.itemPrice.price)
                                                  {
                                                    learners[index].discount_price = this.state.itemPrice.price;
                                                    learners[index].total_after_discount = 0;
                                                  }
                                                }
                                              } 
                                              else if (this.state.applied_coupon_detail.pc_discount_type == 0)
                                              {
                                                
                                                if (this.state.applied_coupon_detail.pc_maximum_discount)
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                    if ((Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.discount_price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = Number(this.state.itemPrice.discount_price) - learners[index].discount_price;

                                                  } else {
                                                    if ((Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100)) > Number(this.state.applied_coupon_detail.pc_maximum_discount))
                                                    {
                                                      learners[index].discount_price     = Number(this.state.applied_coupon_detail.pc_maximum_discount);
                                                    } else {
                                                      learners[index].discount_price     = Number(this.state.itemPrice.price) * (Number(this.state.applied_coupon_detail.pc_discount_rate) / 100);
                                                    }
                                                    learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  }
                                                }
                                                else
                                                {
                                                  if (this.state.itemPrice.discount_price > 0)
                                                  {
                                                      learners[index].discount_price       = this.state.itemPrice.discount_price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                      learners[index].total_after_discount = this.state.itemPrice.discount_price - learners[index].discount_price;
                                                  } else {
                                                      learners[index].discount_price       = this.state.itemPrice.price * (this.state.applied_coupon_detail.pc_discount_rate / 100);
                                                      learners[index].total_after_discount = this.state.itemPrice.price - learners[index].discount_price;
                                                  }
                                                }
                                              }
                                            }
                                            
                                          } else {
                                            learners[index].is_bulk_learner_discount = 0;
                                            learners[index].discount_price = 0;
                                            learners[index].total_after_discount = 0;
                                          }
                                        }
                                      }


                                    }

                                    if (cart[key]['learners'][index])
                                    {
                                      cart[key]['learners'][index].is_bulk_learner_discount = learners[index].is_bulk_learner_discount;
                                      cart[key]['learners'][index].discount_price = learners[index].discount_price;
                                      cart[key]['learners'][index].total_after_discount = learners[index].total_after_discount;
                                      learners[index].item_id = id;
                                    }
                                    localStorage.setItem('mycart', JSON.stringify(cart));

                                  } else {
                                    learners[index].is_bulk_learner_discount = 0;
                                    learners[index].discount_price = 0;
                                    learners[index].total_after_discount = 0;
                                  }
                                  return learners;
                                });
    }

    return (
      <div className="cart-bulk-actions bulk-learner-list item-learners-wrapper">
        <div className="learner-action-list">
          <span className="add-learner-box" onClick={this.addlearner}>
            <svg
              id="Group_2"
              data-name="Group 2"
              xmlns="http://www.w3.org/2000/svg"
              width="11.855"
              height="11.855"
              viewBox="0 0 11.855 11.855"
            >
              <path
                id="Path_16"
                data-name="Path 16"
                d="M3214,485.6v11.855"
                transform="translate(-3208.073 -485.596)"
                fill="none"
                stroke="#2d71fd"
                stroke-width="2"
              ></path>
              <path
                id="Path_17"
                data-name="Path 17"
                d="M0,0V11.855"
                transform="translate(11.855 5.928) rotate(90)"
                fill="none"
                stroke="#2d71fd"
                stroke-width="2"
              ></path>
            </svg>{' '}
            {item.others.remining_seats - learners_count <= 0 &&
            this.state.type == 'booking_event' &&
            item.others.haswaitinglist == '1'
              ? 'Add to Waiting List'
              : 'Add Learner'}
            {item.others.remining_seats != -1 && (
              <span class="remain-seat">
                Remaining Seats:{' '}
                {Number(item.others.remining_seats) - learners_count < 0
                  ? 0
                  : Number(item.others.remining_seats) - learners_count}
              </span>
            )}
          </span>
        </div>
        <div class="add-learner-details-block-wrap item-learner-wrapper">
        {Object.keys(learners).length != 0 &&
          Object.keys(learners).reverse()
            .slice(0, 5)
            .map((index, int_index) => {
              return (
                <div className="add-leaner-details-block">
                  <div className="add-leaner-details">
                    <div className="addlearner-info">
                      <div className="addleaner-name">
                        <span
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            learners[index].is_member == '1'
                              ? 'addleaner-name-icon green-icon'
                              : 'addleaner-name-icon blue-icon'
                          }
                        >{learners[index].name.charAt(0).toUpperCase()}</span>
                        
                        <div className="addlearner-name_email">
                          <p>{learners[index].name}</p>
                          <p class="addleaner-email"><a href="#">{learners[index].email}</a></p>
                          <div>
                          {this.state.itemPrice.isfree != 1 ? (
                        <div
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            learners[index].is_member == '1'
                              ? 'addleaner-cp green-color-cp'
                              : 'addleaner-cp'
                          }
                        >
                          {this.state.itemPrice.member_status == 1 &&
                          _showMember == '1' &&
                          learners[index].is_member == '1'
                            ? _memberLabel
                            : _currentLabel}
                        </div>
                      ) : (
                        _free_course_label
                      )}
                          </div>
                        </div>
                      </div>
                    </div>
                  <div class="price-actions-wrapper">
                    <div className="addlearner-price-info">
                      <div className="addleaner-price">
                        {this.state.itemPrice.isfree != 1 ? (
                          <>
                            <p>Price :
                              <span className="rupee-unicode">
                                {current_currency}
                              </span>
                              {this.state.itemPrice.member_status == 1 &&
                              _showMember == '1' &&
                              learners[index].is_member == '1'
                                ? this.state.itemPrice.member_price
                                : this.state.itemPrice.discount_price > 0
                                ? this.state.itemPrice.discount_price
                                : this.state.itemPrice.price}
                            </p>
                            {learners[index].is_bulk_learner_discount && learners[index].is_bulk_learner_discount  == 1 ?
                              (<p>
                                <span className="rupee-unicode">
                                  {learners[index].discount_price > 0 ? 'Coupon Discount: ' + current_currency + ' ' +learners[index].discount_price : ('')}
                                </span>
                              </p>)
                              : ('')
                            }
                            
                            {learners[index].is_bulk_learner_discount && learners[index].is_bulk_learner_discount  == 1 ?
                              (<p>
                                <span className="rupee-unicode">
                                  {learners[index].total_after_discount > 0 ? 'Total:' + current_currency + ' ' +learners[index].total_after_discount : ('')}
                                </span>
                              </p>)
                              : ('')

                            }
                           
                          </>

                        ) : (
                          ''
                        )}
                      </div>

                      
                    </div>
                    <div className="addleaner-edit-info item-learner-actions-wrapper">
                      <div className="item-learner_action-inner-wrapper">
                        <span
                          className="addleaner-edit item-learner-action"
                          onClick={() =>
                            this.editlearner(learners[index], index)
                          }
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="528.899px"
                            height="528.899px"
                            viewBox="0 0 528.899 528.899"
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
               c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
               C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
               L27.473,390.597L0.3,512.69z"
                              />
                            </g>
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                          </svg>Edit
                        </span>
                        <span
                          className="addleaner-delete item-learner-action"
                          onClick={() => this.removelearner(learners[index])}
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 612 612"
                            style={{ enableBackground: 'new 0 0 612 612' }}
                            width="12px"
                            height="12px"
                            xmlSpace="preserve"
                          >
                            <g>
                              <g>
                                <path
                                  d="M493.8,170.8H118.2c-11.4,0-20.6,9.2-20.6,20.6v321.5c0,54.6,44.5,99.1,99.1,99.1h218.6c54.6,0,99.1-44.5,99.1-99.1V191.4
                       C514.4,180,505.2,170.8,493.8,170.8z M256.5,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z M406,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z"
                                />
                                <path
                                  d="M473.2,32h-89.7v-7.8c0-13.4-10.9-24.2-24.2-24.2H252.7c-13.4,0-24.2,10.9-24.2,24.2V32h-89.7C104.5,32,76.5,60,76.5,94.3
                       v39.9c0,7.1,5.8,12.9,12.9,12.9h433.1c7.1,0,12.9-5.8,12.9-12.9V94.3C535.5,60,507.5,32,473.2,32z"
                                />
                              </g>
                            </g>
                          </svg>Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                
              );
            })}
        </div>
        {Object.keys(learners).length > 5 && (
          <div className="learner-action">
            <div className="learner_lists">
              <p className="apply-text" onClick={this.learnerlisting}>
                +{Object.keys(learners).length - 5} more Learners
              </p>
            </div>
          </div>
        )}

      {Object.keys(waitingList).length !== 0 && (
        <div class="add-learner-details-block-wrap item-learner-wrapper waiting-list-wrapper">
          <h3>Waiting List</h3>
        {Object.keys(waitingList).length != 0 &&
          Object.keys(waitingList).reverse()
            .slice(0, 3)
            .map((index, int_index) => {
              return (
                <div className="add-leaner-details-block">
                  <div className="add-leaner-details">
                    <div className="addlearner-info">
                      <div className="addleaner-name">
                        <span
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            waitingList[index].is_member == '1'
                              ? 'addleaner-name-icon green-icon'
                              : 'addleaner-name-icon blue-icon'
                          }
                        >{waitingList[index].name.charAt(0).toUpperCase()}</span>
                        
                        <div className="addlearner-name_email">
                          <p>{waitingList[index].name}</p>
                          <p class="addleaner-email"><a href="#">{waitingList[index].email}</a></p>
                        </div>
                      </div>
                    </div>
                  <div class="price-actions-wrapper">
                    
                    <div className="addleaner-edit-info item-learner-actions-wrapper">
                      <div className="item-learner_action-inner-wrapper">
                        <span
                          className="addleaner-edit item-learner-action"
                          onClick={() =>
                            this.editWaitingList(waitingList[index], index)
                          }
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="528.899px"
                            height="528.899px"
                            viewBox="0 0 528.899 528.899"
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
               c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
               C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
               L27.473,390.597L0.3,512.69z"
                              />
                            </g>
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                          </svg>Edit
                        </span>
                        <span
                          className="addleaner-delete item-learner-action"
                          onClick={() => this.removeWaitingList(waitingList[index])} 
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 612 612"
                            style={{ enableBackground: 'new 0 0 612 612' }}
                            width="12px"
                            height="12px"
                            xmlSpace="preserve"
                          >
                            <g>
                              <g>
                                <path
                                  d="M493.8,170.8H118.2c-11.4,0-20.6,9.2-20.6,20.6v321.5c0,54.6,44.5,99.1,99.1,99.1h218.6c54.6,0,99.1-44.5,99.1-99.1V191.4
                       C514.4,180,505.2,170.8,493.8,170.8z M256.5,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z M406,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z"
                                />
                                <path
                                  d="M473.2,32h-89.7v-7.8c0-13.4-10.9-24.2-24.2-24.2H252.7c-13.4,0-24.2,10.9-24.2,24.2V32h-89.7C104.5,32,76.5,60,76.5,94.3
                       v39.9c0,7.1,5.8,12.9,12.9,12.9h433.1c7.1,0,12.9-5.8,12.9-12.9V94.3C535.5,60,507.5,32,473.2,32z"
                                />
                              </g>
                            </g>
                          </svg>Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                
              );
            })}
        {Object.keys(waitingList).length > 3 && (
          <div className="learner-action">
            <div className="learner_lists">
              <p className="apply-text" onClick={this.waitinglistlisting}>
                +{Object.keys(waitingList).length - 3} more Waiting Lists
              </p>
            </div>
          </div>
        )}
        </div>
      )}

        {/* <span className="remove-learner apply-text" onClick={this.removeFromCartPopup}>Remove</span> */}
        {this.state.learnerlisting && (
          <LearnerListing
            editlearner={this.editlearner}
            data={this.props.data}
            refresh={this.refresh}
            dissmissmodal={this.dissmissmodal}
            coupon_subscriber_limit={this.props.coupon_subscriber_limit}

          />
        )}
        {this.state.waitinglistlisting && (
          <WaitingListListing
            editlearner={this.editlearner}
            data={this.props.data}
            refresh={this.refresh}
            dissmisswaitmodal={this.dissmisswaitmodal}
            coupon_subscriber_limit={this.props.coupon_subscriber_limit}

          />
        )}
        {this.state.addlearner && (
          <AddLearner
            setdata={this.state.setdata}
            learnerindex={this.state.learnerindex}
            frompopup={this.state.frompopup}
            refresh={this.refresh}
            type={type}
            id={id}
            dissmissmodal={this.dissmissmodal_addlearner}
            show_membermsg={this.show_membermsg}
            isedit={this.state.isedit}
            addToWaitingListStatus={false}
          />
        )}
         {this.state.addWaitingList && (
          <AddWaitingList
            setdata={this.state.setdata}
            waitinglistindex={this.state.waitinglistindex}
            frompopup={this.state.frompopup}
            refresh={this.refresh}
            type={type}
            id={id}
            dissmisswaitmodal={this.dissmisswaitmodal_addwaitinglist}
            show_membermsg={this.show_membermsg}
            isedit={this.state.isedit}
            addToWaitingListStatus={true}
          />
        )}

        {this.state.memberStatus && (
          <MemberpriceApplied
            show_membermsg={this.show_membermsg}
            membermsg={this.state.memberMsg}
            dissmissmodal_membermsg={this.dissmissmodal_membermsg}
          />
        )}
      </div>
    );
  }
}
